import moment from 'moment';
import 'moment/locale/fr';
import 'moment/locale/sr';
import 'moment/locale/de';
import { getRegion } from '../helpers/getRegion';

export const translation = {
  EN: {
    COMMON: {
      ['Terms and Conditions']: 'Terms & Conditions',
      termsLink:
        'https://sixtix.com/documents/SIXTIX_NL_Terms_of_Service_2025_EN.pdf',
      privacyPolicy: 'Privacy Policy',
      privacyPolicyLink:
        'https://sixtix.com/documents/SIXTIX_NL_Privacy_Policy_2025_EN_v24_07_25.pdf',
      cookie: 'Cookie Policy',
      cookieLink:
        'https://sixtix.com/documents/SIXTIX_NL_Cookie_Statement_2025_EN.pdf',
      back: 'Back',
      show: 'Info',
      firstNextPageBtn: 'WANNA KNOW MORE?',
      secondNextPageBtn: 'The six of tix',
      support: 'Support',
      formErrors: {
        'empty fields': 'Input fields cannot be empty',
        'Email is not valid': 'Email is not valid',
      },
      passwordRules: {
        title: 'A valid password should:',
        rules: [
          'have more than 8 characters',
          'contain a capital letter',
          'contain a lowercase',
          'contain a number',
          'contain a symbol',
        ],
      },
      'Passwords do not match': 'Passwords do not match',
      Home: 'Home',
    },
    FOOTER: {
      details_title: 'We-Sell',
      address: [
        'Antje Breijerstraat 205',
        '2132 ZT Hoofddorp',
        'The Netherlands',
      ],
      details: [
        'KvK: 98226045',
        'BTW: NL868407586B01',
        'IBAN: NL16ABNA0147950686',
      ],
    },
    LOGIN: {
      formTitle: 'Login as an event organizer',
      login: 'Login',
      ['No account yet?']: 'No account yet?',
      ['Create account']: 'Create account',
      ['Forgot password']: 'Forgot password',
      ['Create a ticket buyer account']: 'Create a ticket buyer account',
      ['Login as ticket buyer']: 'Login as ticket buyer',
      mainTitle: 'Get Started Quickly',
      content:
        'Go live instantly, without any hassle. Get immediate access to create your ticketshop. Need to send out a guestlist, or get your pre-registration form online? This ticketing system is built for organizers who want to control everything themselves.',
    },
    TOGETHER: {
      name: 'Name',
      email: 'Email',
      info: 'Extra info',
      submit: 'Submit',
      ['Do it together?']: 'Team up?',
      mainTitle: 'Team up?',
      content:
        "From experience, we know the challenges and opportunities you face as an organizer. You don't always have the right team, expertise, network, or budget. That's exactly where we come in. We're open to building a true partnership, in every way. So let's sit down to discuss your wishes, opportunities, and possibilities. Give us a call to schedule a meeting!",
    },
    TOGETHER_SALE: {
      name: 'Name',
      email: 'Email',
      info: 'Extra info',
      submit: 'We contact you!',
      ['Do it together?']: 'Team up?',
      mainTitle: '25% Off Your Current Ticket Fee!',
      contentHTML:
        'Switch your ticketing to SixTix now and get a 25% discount on your current ticket fee. Just fill in your details and send us your current contract to qualify. Please note: This offer is only valid for switches made before January 1, 2026.',
    },
    LOST_TICKET: {
      ['Lost ticket']: 'Lost ticket',
      ['BANK STATEMENT']: 'BANK STATEMENT',
      name: 'Name',
      description: 'Description',
      charasteristic: 'Charasteristic',
      beneficiary: 'Beneficiary',
      amount: 'Amount',
      IBAN: 'IBAN beneficairy',
      ['Reference beneficairy']: 'Reference beneficairy',
      ['Reference bank']: 'Reference bank',
      date: 'Date',
      ['Name of the event']: 'Name of the event',
      ['Date of purchase']: 'Date of purchase',
      email: 'Email',
      ['Order number']: 'Order number',
      submit: 'Submit',
      mainTitle: 'Lost Your Ticket?',
      contentHTML: `
        No problem! You can easily retrieve your tickets yourself. Using your order number and email, you'll have your tickets back in no time. You can find the order number on your bank statement (as shown on the right). After entering your order number and email address, just click 'Get tickets'. The tickets will instantly appear on your screen, ready for you to download. Please note: the tickets will not be re-sent to your email address.
      `,
    },
    REGISTER: {
      email: 'Email',
      password: 'Password',
      confirmPassword: 'Confirm password',
      organization: 'Organization name',
      country: 'Country',
      phone: 'Contact person phone number',
      ['I agree to the']: 'I agree to the',
      apply: 'Apply',
      mainTitle: "Awesome! You've made a great choice.",
      contentHTML: `
      After you register, we'll get in touch shortly to give you a quick tour of the dashboard.
      <br />
      <br />
      And don't worry, creating an account is completely commitment-free (see our terms & conditions).
      <br />
      <br />
      For custom plans or pricing, feel free to contact us directly at 
      <a
        href="mailto:hallo@sixtix.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        hallo@sixtix.com
      </a>.
      `,
      ['I want to start']: 'Let’s start!',
      ['Begin']: 'LET’S START!',
      ['Passwords do not match']: 'Passwords do not match',
    },
    HERO: {
      subtitleHTML: '<p>SIMPLE TICKETING, FULL CONTROL.</p>',
    },
    EASY_BUY: {
      title: 'We make ticketing simple,',
      subtitle: "But hey, it's your call.",
    },
    ADVANTAGES: {
      title: "WITH US, YOU'RE ALWAYS IN CONTROL",
      articles: [
        {
          title: 'With us you’re always in controle',
          body: "We offer one system with all the tools you need. We're all about giving you control. Sell what you want, where you want, whenever you want. Online through your website and social media, or in-person with our point-of-sale (POS) system. From tickets and merchandise to reservations and even monthly subscriptions. We make it all possible.",
        },
        {
          title: 'Transparent Cash Flow, Instantly',
          body: "Control over your cash flow is essential. With us, you get your money instantly—no more waiting for payouts. That's why we have a zero-touch policy. Every payment is instantly split into three parts: your revenue, our service fee, and the payment provider's transaction cost. Your share goes straight to your bank account. Simple, transparent, and completely fair. Just the way it should be.",
        },
        {
          title: "Unlock Your Data's Potential",
          body: "There's more to your data than you think. That's why we've developed powerful features that give you the tools to maximize your profits and create new revenue streams from your ticket buyers.",
        },
      ],
    },
    SIX_IN_TIX: {
      title: 'THE SIX OF TIX',
      text: 'Your All-in-One Platform to manage everything; quickly connect with your audience, sell your products with ease, and get your money instantly. Simple and transparent.',
      'Custom Dashboard': 'Custom Dashboard',
      'Design your Shop': 'Design your Shop',
      'Easy Setup': 'Easy Setup',
      'Sell on Socials': 'Sell on Socials',
      'Combined Statistics': 'Combined Statistics',
      'Instant Payment': 'Instant Payment',
    },
    DASHBOARD: {
      title: 'Controle of your dashboard',
      subsections: [
        {
          title: 'Controle you’re secondary ticket sales',
          content:
            'You set the price and decide which channels can be used for resale. Lock your QR code and get access to our internal Secondary Ticketing System, with options like partial refunds, loyalty refunds, or guaranteed refunds (full or percentage-based).',
        },
        {
          title: 'Choose your sales channels',
          content:
            'Sell through a point-of-sale (POS) system, secure or public online links, invitations or guest lists. The choice is yours. Manage everything yourself by creating multiple links in our system. You can even take control and decide who buys what.',
        },
        {
          title: 'Sell on your terms',
          content:
            'Reward loyal fans with exclusive deals in your "friends-only WhatsApp group" without losing the trust of your other customers.',
        },
        {
          title: 'Automate Your Sales Strategy',
          content:
            'Define your marketing strategy and align our sales planner to it. No more getting out of bed just to push a button.',
        },
        {
          title: 'Control Your Cash Flow & Invoicing',
          content:
            "It's your money, not ours. We maintain a zero-touch policy, which means we never touch your funds.",
        },
      ],
    },
    SHOP: {
      title: 'CONTROLE your SHOP',
      subsections: [
        {
          title: 'Your brand; Your shop',
          content:
            "It's your brand and they are your customers. That's why you can customize everything to match your brand's identity; from the colors of your webshop to the complete customer journey. You're in control.",
        },
        {
          title: 'Any type of shop Is possible',
          content:
            "Seated/standing tickets, time slots, regular tickets, season passes, memberships, reservations, pre-registrations, merchandise — whatever you want to sell, it's entirely up to you. We provide all the options and ensure a user-friendly experience for your customers.",
        },
        {
          title: 'Design your own website and shop:',
          content:
            "Proud of your brand? We get it. Set up your custom shop in no time using one of our templates. Our support doesn't stop at the shop; if you don't have a website, our team is ready to help you out.",
        },
        {
          title: 'Personal Connection',
          content:
            "If you want to truly connect with your audience, you need more than just a chat function. Create a direct communication channel through a customer or member login. This gives you a clear profile of their purchases, allowing you to offer personal deals or early access to exclusive products or tickets. It's entirely up to you.",
        },
        {
          title: 'Choose Your Sales Methods',
          content:
            "We've made the sales process as user-friendly and flexible as possible, giving you a wide range of choices. Sell through different links to track your stats and improve your campaigns. Invite your sponsors with a secure link, send extra guest list tickets to your hosts, or sell via brand ambassadors on the street. The choice is all yours. Have a specific sales method our software doesn't support yet? Let us know, and we'll find a solution together.",
        },
      ],
    },
    SETTINGS: {
      title: 'Controle over all settings',
      subsections: [
        {
          title: 'Face-to-Face Sales on Your Mobile',
          content:
            'We make sure you can sell anywhere—not just online. Download our accreditation app with its integrated POS (Point of Sale) feature, allowing you to sell any product you’ve configured via QR codes, payment links, or Tap2Pay',
        },
        {
          title: 'Secure your customer experience',
          content:
            'Naturally, you want everything to be secure and well-managed for your customers. That includes access to the latest technologies. We offer seamless integration with Apple and Google Wallet, protected secondary ticket sales with dynamic QR codes, and for a more exclusive touch, secure NFC solutions for physical cards. The choice is yours.',
        },
        {
          title: 'Get it Up, GO Fast',
          content:
            "Set your default settings once, then just copy a previous event. We make sure you never have to repeat unnecessary steps. Simple as that! And if you get stuck? We're here to provide fast, personal support.",
        },
        {
          title: 'Embed on Any Website',
          content:
            "Place a ticket button anywhere, offline via a QR code or online using an iframe. Set it up once, and you're done. The button is fully responsive and automatically syncs with your event settings.",
        },
        {
          title: 'Instant Short Links',
          content:
            "No hassle with short URL services. Just type your unique reference in the 'create link' section.",
        },
      ],
    },
    MARKETING: {
      title: 'CONTROL over all data',
      subsections: [
        {
          title: 'Seamless Online Tracking',
          content:
            'Google Tag Manager is fully integrated into our own internal tagging system. Easily organize and enrich your database based on interests or purchasing behavior to make your marketing strategy more successful.',
        },
        {
          title: 'Customize Your Sales Fields',
          content:
            'Easily add custom fields to your forms, such as yes/no, multiple-choice questions (A, B, C), or open-ended questions.',
        },
        {
          title: 'Social Selling',
          content:
            'Start selling on Facebook & Instagram in minutes. Easily add tickets to promote and sell them directly on Facebook. We ensure a seamless sales experience, allowing you to sell directly from your Instagram or TikTok shop.',
        },
        {
          title: 'Build Loyalty with Member / Buyer Logins',
          content:
            'Give your customers their own member area,you gain valuable insights into your customer. with a clear overview of their purchases, personal details, Plus, you can reward members through loyalty programs, like giving them early access to ticket sales or sending personalized offers.',
        },
        {
          title: 'Automated Marketing',
          content:
            "Not a marketing expert, or just not your thing? No worries. Our marketing team has got you covered. Using our automated tools, they'll get your campaign online in no time.",
        },
      ],
    },
    STATISTICS: {
      title: 'controle all your statistics',
      subsections: [
        {
          title: 'Easy APP logins',
          content:
            "Quickly and easily create teams with secure logins and assign specific permissions to each user. From scanning to sales, everything can be configured in your dashboard and viewed clearly in one app. Don't want them to see the stats? No problem, just turn them off. Easily manage all access levels, whether by QR code or NFC (wallet). Of course, all stats can be traced back to individual users.",
        },
        {
          title: 'Publish Your Own Fanbase Application',
          content:
            'Another powerful solution we offer is our white-label app, WE-PLACE, a platform and communication channel for building and maintaining communities, fully tailored to your needs.',
        },
        {
          title: 'Team Management',
          content:
            'Easily manage all roles and permissions within your various teams. You decide who can see which stats per device, entrance, or ticket type. Everything is fully customizable.',
        },
        {
          title: 'Real-Time Statistics',
          content:
            "Get constant access to your data through the app. Thanks to our lightning-fast scan speed (multiple devices sync within seconds, even with limited connectivity), your stats are updated instantly. So you're always up to date.",
        },
        {
          title: 'Compare Your Stats',
          content:
            'Our comparison tool makes it easy to overlay the data from one event onto another. This gives you a quick and clear overview of where sales trends differ. You can even filter by ticket type, helping you make smarter forecasts for the future.',
        },
      ],
    },
    FINANCE: {
      title: 'Control over your  finance',
      subsections: [
        {
          title: 'Choose Your Payment Methods',
          content:
            "Is your favorite payment method not listed? Let us know, and we'll integrate it for you!",
        },
        {
          title: 'Connect Tap2Pay to the POS App',
          content:
            'Turn any Android or iOS device into a mobile payment terminal, directly linked to the POS function within our accreditation app.',
        },
        {
          title: 'We connect your bank account for your payment',
          content:
            "We don't want to touch your money. That's why payments are processed on your behalf and instantly split into: 1) our product fees, 2) payment provider transaction costs, and 3) your ticket revenue. Available immediately in your wallet.",
        },
        {
          title: 'Manage Your Own Refunds & Cancellations',
          content:
            "You don't have to wait on us to refund. From now on, you handle it yourself and get instant insight into cancellations and detailed information about every transaction.",
        },
        {
          title: 'Choose Your Own Payday',
          content:
            'Because you are in control of your payments you don’t have to wait for us to get your money on your account. Schedule payouts as often as you need, because a healthy cash flow is essential.',
        },
      ],
    },
  },
  NL: {
    COMMON: {
      ['Terms and Conditions']: 'Algemene Voorwaarden',
      termsLink:
        'https://sixtix.nl/documents/SIXTIX_NL_Algemene_Voorwaarden_2025_NL.pdf',
      privacyPolicy: 'Privacybeleid',
      privacyPolicyLink:
        'https://sixtix.nl/documents/SIXTIX_NL_Privacyverklaring_2025_NL_v24_07_25.pdf',
      cookie: 'Cookiebeleid',
      cookieLink:
        'https://sixtix.nl/documents/SIXTIX_NL_Cookieverklaring_2025_NL.pdf',
      back: 'Terug',
      show: 'Info',
      firstNextPageBtn: 'nieuwsgierig?',
      secondNextPageBtn: 'De six of tix',
      support: 'Steun',
      formErrors: {
        'empty fields': 'Invoervelden kunnen niet leeg zijn',
        'Email is not valid': 'E-mailadres is niet geldig',
      },
      passwordRules: {
        title: 'Een geldig wachtwoord moet:',
        rules: [
          'meer dan 8 tekens bevatten',
          'een hoofdletter bevatten',
          'een kleine letter bevatten',
          'een cijfer bevatten',
          'een symbool bevatten',
        ],
      },
      'Passwords do not match': 'Wachtwoorden komen niet overeen',
      Home: 'Thuis',
    },
    FOOTER: {
      details_title: 'SixTix NL',
      address: ['Vlierweg 12', '1032 LG Amsterdam', 'The Netherlands'],
      details: [
        'KvK: 97296945',
        'BTW: NL867990399B01',
        'IBAN: NL97RABO0125666853',
      ],
    },
    LOGIN: {
      login: 'Log in',
      formTitle: 'Log in als evenementenorganisator',
      ['No account yet?']: 'Nog geen account?',
      ['Create account']: 'Maak een account aan',
      ['Forgot password']: 'Wachtwoord vergeten',
      ['Create a ticket buyer account']: 'Registreer een ticketkoper account',
      ['Login as ticket buyer']: 'Inloggen als ticketkoper',
      mainTitle: 'Snel van start',
      content:
        'Meteen live zonder gedoe. Direct toegang tot tickets. Gastenlijst management. Pre-registratie formulieren. Bedoeld voor organisatoren die meteen live willen met de kaartverkoop. (meer geschikt voor festivals, clubs of eenmalige events).',
    },
    TOGETHER: {
      name: 'Naam',
      email: 'E-mailadres',
      info: 'Extra info',
      submit: 'Indienen',
      ['Do it together?']: 'Samen doen?',
      mainTitle: 'Samen doen?',
      content:
        'Uit ervaring begrijpen we heel goed voor welke uitdagingen, maar ook voor welke kansen je als organisator vaak komt te staan. Je moet dan maar net het team met de juiste expertise, het netwerk en/of het budget ervoor hebben. Precies hier willen wij graag om de hoek kijken. Wij staan open om het écht samen te doen. Op alle vlakken. Dus laten we om tafel gaan om jouw wensen, kansen en mogelijkheden te bespreken. Bel ons en maak snel een afspraak!',
    },
    TOGETHER_SALE: {
      name: 'Naam',
      email: 'E-mailadres',
      info: 'Extra info',
      submit: 'Je hoort van ons!',
      ['Do it together?']: 'Samen doen?',
      mainTitle: 'Nu 25% korting op je huidige ticketfee!',
      contentHTML: `
        Als je nu jouw ticketing overzet naar SixTix krijg je 25% korting op je huidige ticketfee. Vul je gegevens in en stuur je huidige contract mee.
        <br />
        <br />
        Let op: deze actie geldt alleen bij overstappen vóór 1 januari 2026.
      `,
    },
    LOST_TICKET: {
      ['Lost ticket']: 'Ticket Kwijt',
      ['BANK STATEMENT']: 'BANKAFSCHRIFT',
      name: 'Naam',
      description: 'Omschrijving',
      charasteristic: 'Kenmerk',
      beneficiary: 'Begunstigde',
      amount: 'Bedrag',
      IBAN: 'IBAN begunstigde',
      ['Reference beneficairy']: 'Referentie begunstigde',
      ['Reference bank']: 'Referentiebank',
      date: 'Datum',
      ['Name of the event']: 'Naam van het evenement',
      ['Date of purchase']: 'Aankoopdatum',
      email: 'E-mailadres',
      ['Order number']: 'Ordernummer',
      submit: 'Indienen',
      mainTitle: 'Ticket Kwijt of niet Ontvangen?',
      contentHTML: `
        Geen probleem! Je kunt je tickets eenvoudig zelf opnieuw opvragen. Met
        behulp van je bestelnummer & e-mail heb je de tickets binnen no-time
        weer in beeld. Het bestelnummer vind je op je bankafschrift (zoals
        aangegeven in het groen aan de rechterkant). Nadat je het bestelnummer
        en bijbehorende e-mailadres hebt ingevoerd, klik je op &apos;
        <span style={{ color: '#ff7305' }}>Get tickets</span>&apos;. De
        tickets verschijnen direct op je scherm, waarna je ze gemakkelijk kunt
        downloaden.
        <br />
        <br />
        <span style={{ color: '#ff7305' }}>Let op</span>: de tickets worden
        niet opnieuw naar je e-mailadres verstuurd.
      `,
    },
    REGISTER: {
      email: 'E-mailadres',
      password: 'Wachtwoord',
      confirmPassword: 'Wachtwoord bevestigen',
      organization: 'Organisatie naam',
      country: 'Land',
      phone: 'Telefoonnummer contactpersoon',
      ['I agree to the']: 'Ik ga akkoord met de',
      apply: 'Toepassen',
      mainTitle: 'Tof, wij behouden dat je een goede keuze hebt gemaakt',
      contentHTML: `
        Na je registratie, zullen zo spoedig mogelijk contract met je opnemen met betrekking tot wat uitleg over het dashboard.
        <br />
        <br />
        En maak je geen zorgen met het registreren van een account zit je zeker nergens aan vast. (zie algemene voorwaarden).
        <br />
        <br />
        Voor aangepaste voorwaarden of prijzen kan je ons ook direct benaderen 
        <a
          href="mailto:hallo@sixtix.nl"
          target="_blank"
          rel="noopener noreferrer"
        >
          hallo@sixtix.nl
        </a>
        .
      `,
      ['I want to start']: 'Ik wil beginnen',
      ['Begin']: 'BEGINNEN!',
      ['Passwords do not match']: 'Wachtwoorden komen niet overeen',
    },
    HERO: {
      subtitleHTML: '<p>TICKETING, MAAR NU HEB JIJ DE <br /> CONTROLE</p>',
    },
    EASY_BUY: {
      title: 'Wij maken ticketing makkelijker,',
      subtitle: 'maar dat bepaal jij helemaal zelf.',
    },
    ADVANTAGES: {
      title: 'want bij ons ben jij altijd in control',
      articles: [
        {
          title: 'In het verkopen',
          body: 'Wij bieden één systeem dat jou alle tools geeft die je nodig hebt. Jij bent in control. Verkoop alles wat je wilt, waar en wanneer je maar wilt. Online via je website of social media, of persoonlijk met een kassasysteem (POS). Van tickets en producten tot reserveringen en zelfs maandelijkse abonnementen. Via ons is alles mogelijk.',
        },
        {
          title: 'Met het innen',
          body: 'Controle over je cashflow is essentieel. Daarom hebben wij een zero-touch beleid. Elke betaling wordt direct gesplitst in jouw inkomsten, onze product kosten en de transactiekosten van de betaalprovider. En met onze integratie van Pay.nl staan jouw inkomsten meteen op je eigen wallet. Heel eenvoudig en heel transparant.',
        },
        {
          title: 'Bij het kapitaliseren',
          body: 'Je kunt veel meer met je data dan je denkt. Daarom hebben we extra functies ontwikkeld zodat jij de tools krijgt om zelf je winst te maximaliseren en extra inkomstenstromen te creëren voor jouw ticket kopers.',
        },
      ],
    },
    SIX_IN_TIX: {
      title: 'de six in tix',
      text: 'Eén platform waar je alles regelt; snel contact met je publiek, verkoop je producten met gemak en het geld meteen op je rekening. Makkelijk en transparant.',
      'Custom Dashboard': 'Jouw Dashboard',
      'Design your Shop': 'Brand je Shop',
      'Easy Setup': 'Snel Online',
      'Sell on Socials': 'Verkoop op Socials',
      'Combined Statistics': 'Vergelijk je Statistieken',
      'Instant Payment': 'Direct je Geld',
    },
    DASHBOARD: {
      title: 'Controle over alles',
      subsections: [
        {
          title: 'Krijg controle over je secondaire kaarten verkoop',
          content:
            'Vergrendel je QR-code en krijg toegang tot ons interne Secondary Ticketing System, met opties zoals gedeeltelijke terugbetalingen, loyaliteit-terugbetalingen of gegarandeerde terugbetalingen (volledig of op procentbasis).',
        },
        {
          title: 'Bepaal je ticket instellingen per doelgroep',
          content:
            'Beloon trouwe fans met exclusieve deals in je "friends-only WhatsApp-group," zonder het vertrouwen van je andere klanten te schaden.',
        },
        {
          title: 'Kies per verkoopkanaal je verkoop prijs',
          content:
            'Via een kassasysteem (POS), beveiligde of open online links, uitnodigingen of gastenlijsten. De keus is aan jou. Regel alles zelf door meerdere Links aan te maken in ons systeem. Je kan zelfs zoveel controle nemen dat je bepaald wie wat koopt.',
        },
        {
          title: 'Automatiseer je sales planning',
          content:
            'Bepaal je marketing strategie, en  stem onze sales planner er op af. Nooit meer je bed uit om op de knop te drukken.',
        },
        {
          title: 'Betaal je zelf uit',
          content:
            'Het is jouw geld, niet het onze. Wij hanteren een zero-touch beleid en komen dus nergens aan.',
        },
      ],
    },
    SHOP: {
      title: 'CONTROLE OVER JE SHOP',
      subsections: [
        {
          title: 'Jouw brand jouw eigen shop',
          content:
            'Het is jouw merk en het zijn jouw klanten. Daarom kun je het inrichten naar de wensen van jouw merk; van de kleuren van jouw webshop en zelfs de volledige customer journey. Jij bepaalt.',
        },
        {
          title: 'Verkoop op de manier dat jij wilt',
          content:
            'Zit/staanplaatsen / tijdslots / producten / reguliere kaartverkoop / seizoenskaarten / memberships / reserveringen / pre-registratie. Wat je ook wil verkopen. Dat is geheel aan jou. Wij bieden alle mogelijkheden aan en zorgen voor een gebruiksvriendelijke ervaring voor je klanten.',
        },
        {
          title: 'Een veilige customer experience',
          content:
            'Natuurlijk wil je dat alles veilig en goed geregeld is. En dat alle nieuwste technologieën beschikbaar zijn voor je klanten. Naadloze integratie met Apple en Google Wallet bijvoorbeeld.  Of beschermde secundaire verkoop met dynamische QR-codes. Liever exclusiever? Wat dacht je van onze beveiligde NFC-oplossingen voor fysieke kaarten? De keuze is aan jou.',
        },
        {
          title: 'In direct contact met je kaartkopers',
          content:
            'Je wil meer dan alleen een chatfunctie als je echt contact wil met je publiek. Creëer via ons een communicatiekanaal via een klant of member login. Heb je meteen een duidelijk profiel van hun aankopen en kun je persoonlijke aanbiedingen en/of vroegtijdige toegang geven tot exclusieve producten of tickets? Dat bepaal je helemaal zelf.',
        },
        {
          title: 'Meerdere shops in shop',
          content:
            'Wij hebben het verkoopproces zo gebruiksvriendelijk en flexibel mogelijk gemaakt, zodat je echt heel veel keuze hebt. Verkoop via verschillende links om je statistieken te volgen en campagnes te verbeteren. Nodig je sponsors uit via een beveiligde link, stuur extra guest list tickets naar je hosts, of verkoop via ambassadeurs op straat. De keuze is reuze. Heb je een specifieke verkoopmethode die onze software nog niet ondersteunt? Laat het ons weten, dan zoeken we samen naar een oplossing.',
        },
      ],
    },
    SETTINGS: {
      title: 'CONTROLE OVER JE PRODUCTEN',
      subsections: [
        {
          title: 'Verkoop face2face via je mobiel',
          content:
            'Wij regelen dat je overal kunt verkopen. Dus niet alleen online. Download onze accreditatie-app met geïntegreerde kassafunctie (POS) waarmee je ieder ingesteld product kunt verkopen via QR-codes, betaallinks of Tap2Pay (met ondersteuning voor Apple Pay, Google Pay en fysieke betaalkaarten).',
        },
        {
          title: 'Een veilige customer experience',
          content:
            'Implementatie op elke type website. Plaats overal een ticket knop; offline via QR-code of online via iframe. Eén keer instellen en klaar. De knop is volledig responsive en synchroniseert automatisch met jouw event-instellingen.',
        },
        {
          title: 'Custom webshops en websites',
          content:
            'Trots op je merk? Dat begrijpen wij. Zet je custom winkel razendsnel op met een van onze templates. We helpen je niet alleen met je shop. We helpen je niet alleen met je shop; ook als je geen website hebt staat het team voor je klaar.',
        },
        {
          title: 'Implementatie op elke type website',
          content:
            'Plaats overal een ticket knop, offline via QR-code of online via iframe.  Eén keer instellen en klaar. De knop is volledig responsive en synchroniseert automatisch met jouw event-instellingen.',
        },
        {
          title: 'Direct een short link',
          content:
            "Geen gedoe met korte URL's nodig. Typ gewoon jouw unieke referentie in de 'create link' omgeving.",
        },
      ],
    },
    MARKETING: {
      title: '',
      subsections: [
        {
          title: 'Koppel elke vorm van online tracking',
          content:
            'Google Tag Manager is volledig geïntegreerd in ons eigen interne tagging systeem. Orden en verrijk je database eenvoudig op interesses of koopgedrag om je marketingstrategie succesvoller te maken.',
        },
        {
          title: 'Stel extra vragen aan je kopers',
          content:
            'Voeg eenvoudig aangepaste velden toe aan je formulieren zoals ja/nee, meerkeuzevragen (ABC) of open vragen.',
        },
        {
          title: 'Publiceer je eigen fanbase applicatie',
          content:
            'Een andere krachtige oplossing die wij bieden is een white-label app, WE-PLACE, een platform voor het bouwen en onderhouden van communities, volledig afgestemd op jouw wensen.',
        },
        {
          title: 'Start je eigen loyaliteitsprogramma',
          content:
            "Bied je klanten hun eigen member-omgeving aan, met een handig overzicht van alle aankopen, alle persoonlijke gegevens en om support aan te vragen. Daarnaast kun je leden belonen via loyaliteitsprogramma's, zoals vroegtijdige toegang tot verkoopmomenten of gepersonaliseerde aanbiedingen.",
        },
        {
          title: 'Activeer de kopers login',
          content:
            'Door kopersprofielen aan te laten maken, krijg je bruikbare inzichten in jouw klanten. Wij verzamelen wel de waardevolle data voor je, zoals eerdere aankopen, favoriete verkoopkanalen en koopgedrag (bijvoorbeeld early-bird kopers).',
        },
      ],
    },
    STATISTICS: {
      title: 'CONTROLE OVER JE CIJFERS',
      subsections: [
        {
          title: 'Makkelijke login met teams',
          content:
            'Maak snel en makkelijk teams aan met beveiligde logins en geef per gebruiker bepaalde rechten. Van scannen tot verkopen: alles is in te stellen in je dashboard en vervolgens overzichtelijk te zien in 1 app. Wil je liever niet dat ze de statistieken zien? Geen probleem, zet die dan uit. Beheer eenvoudig alle toegangsniveaus, of het nou met QR-code of NFC (wallet) is. Uiteraard zijn de statistieken terug te leiden per gebruiker.',
        },
        {
          title: 'Creeer jouw organisatie met ons gebruiksmanagement tool',
          content:
            'Beheer heel makkelijk alle rollen en rechten binnen je verschillende teams. Bepaal zelf wie welke statistieken mag zien per apparaat, ingang of tickettype. Alles is volledig aanpasbaar.',
        },
        {
          title: 'Online en offline scannen',
          content:
            'Bij ons geen paniek als je zonder internet zit of een zwakke verbinding hebt. Creëer vooraf voor je scanners een intern Wi-Fi-netwerk zodat je apparaten naadloos met elkaar synchroniseren. Gebruik elk merk of apparaat; iOS/OS, Android/Google, Huawei, Microsoft, Linux. Allemaal mogelijk.',
        },
        {
          title: 'Altijd en overal live inzicht',
          content:
            'Via de app krijg je altijd toegang tot je data. Dankzij onze super scansnelheid (meerdere apparaten synchroniseren binnen seconden, zelfs bij beperkte verbindingen) worden je statistieken onmiddellijk bijgewerkt. Dus je bent altijd up to date.',
        },
        {
          title: 'Meten is weten',
          content:
            'Met onze vergelijkingstool leg je de cijfers van het ene evenement makkelijk over het andere evenement. Zo zie je snel en overzichtelijk waar de verkooptrends in afwijken. Ook per type ticket instelbaar om zo een voorspelling te kunnen maken.',
        },
      ],
    },
    FINANCE: {
      title: 'CONTROLE OVER JE GELD',
      subsections: [
        {
          title: 'Kies je eigen online betaalmethodes',
          content:
            'Staat jouw favoriete betaalmethode er niet tussen? Laat het ons weten, dan integreren we deze voor jou!',
        },
        {
          title: 'Afrekenen op je mobiel via P.O.S. app',
          content:
            'Maak van elk Android- of iOS-apparaat een mobiele betaalterminal, direct gekoppeld aan de kassa functie binnen onze accreditatie-app.',
        },
        {
          title: 'Koppel je bankrekening voor direct split payments',
          content:
            'We willen niet aan jouw geld komen, daarom worden betalingen meteen namens jou verwerkt en automatisch verdeeld in: 1) product kosten, 2) transactiekosten van de betaalprovider en 3) ticketinkomsten. Direct beschikbaar in jouw wallet.',
        },
        {
          title: 'Regel zelf je refunds en annuleringen',
          content:
            'Je hoeft niet te wachten met terugbetalingen. Vanaf nu regel je het zelf en heb je direct inzicht in annuleringen en gedetailleerde informatie over elke transactie.',
        },
        {
          title: "Kies zelf je 'pay day'",
          content:
            'Plan uitbetalingen zo vaak als je nodig vindt, want een gezonde cashflow is essentieel.',
        },
      ],
    },
  },
};

export const getTranslation = () => {
  const domen = getRegion();

  switch (domen) {
    case 'nl':
      moment.locale('de');
      return translation.NL;

    default:
      moment.locale('en');
      return translation.EN;
  }
};
